<script setup>
import FormButton from '@/components/Atoms/FormButton.vue'
import FormSwitch from '@/components/Atoms/FormSwitch.vue'
import DropDownMenu from '@/components/Atoms/DropDownMenu.vue'
import DropDownMenuItem from '@/components/Atoms/DropDownMenuItem.vue'
import IconBase from '@/components/icon/IconBase.vue'
import IconPlus from '@/components/icon/IconPlus.vue'
import IconFolderOutline from '@/components/icon/IconFolderOutline.vue'
import IconEdit from '@/components/icon/IconEdit.vue'
import IconBin from '@/components/icon/IconBin.vue'
import IconChevronSmall from '@/components/icon/IconChevronSmall.vue'
import DestinationRow from './DestinationRow.vue'
import { usePlatformListContext } from './platformListContext'
import { showModal } from '@/Utils/modalBus'

const props = defineProps({
	group: {
		type: Object,
		required: true,
	},
})

const ctx = usePlatformListContext()

function truncatedName(name) {
	return name.length > 10 ? name.slice(0, 10) + '...' : name
}

function addDestination() {
	ctx.openAddPlatformForGroup(props.group.name)
	showModal('modal-add-platform')
}
</script>

<template>
	<div class="mb-4 bg-surface-1 rounded-xl !p-4 min-w-0 max-w-full">
		<div class="flex justify-between items-center cursor-pointer gap-3" @click="ctx.toggleGroup(group.name)">
			<div class="flex flex-row items-center gap-2 min-w-0">
				<icon-base width="18" height="18" :widthViewBox="24" :heightViewBox="24" fill="none" class="text-surface-7 shrink-0">
					<icon-folder-outline />
				</icon-base>
				<h3 class="text-base font-medium text-white mb-0 truncate">{{ truncatedName(group.name) }}</h3>
				<span class="text-xs font-medium text-white bg-surface-4 min-w-[20px] h-5 inline-flex items-center justify-center px-1.5 rounded-full">
					{{ group.selected.length }}
				</span>
			</div>
			<div class="flex flex-row items-center gap-2 shrink-0">
				<FormButton
					type="secondary"
					class="md:w-[155px] flex items-center justify-center w-[40px]"
					@click.stop="addDestination"
				>
					<icon-base class="md:mr-2 mr-[0px]" fill="none">
						<icon-plus />
					</icon-base>
					<span class="hidden md:inline">New destination</span>
				</FormButton>
				<div @click.stop>
					<FormSwitch
						v-model="ctx.groupToggleStateMap[group.name]"
						label-position="left"
						label-styles="text-sm text-surface-9"
						:disabled="ctx.cannotTogglePlatforms"
						@change="ctx.toggleGroupedPlatforms(group.name)"
					/>
				</div>
				<div @click.stop>
					<DropDownMenu position="right" type="secondary" isIcon no-border>
						<template #toggle-button>
							<img src="@/assets/icons/settings.svg" alt="Settings" class="cursor-pointer" />
						</template>
						<template #menu-items>
							<DropDownMenuItem @click="ctx.requestGroupEdit(group.name)">
								<div class="flex items-center">
									<icon-base class="mr-2" fill="none">
										<icon-edit />
									</icon-base>
									Edit
								</div>
							</DropDownMenuItem>
							<DropDownMenuItem @click="ctx.deleteGroup(group.name)">
								<div class="flex items-center hover:text-error">
									<icon-base class="mr-2" fill="none">
										<icon-bin />
									</icon-base>
									Remove
								</div>
							</DropDownMenuItem>
						</template>
					</DropDownMenu>
				</div>
				<icon-base
					fill="none"
					class="cursor-pointer transition-transform duration-200"
					:class="{ 'rotate-180': !ctx.isGroupCollapsed(group.name) }"
					@click.stop="ctx.toggleGroup(group.name)"
				>
					<icon-chevron-small />
				</icon-base>
			</div>
		</div>
		<div
			v-if="!ctx.isGroupCollapsed(group.name)"
			class="mt-2 destinations-platform-list flex flex-col min-w-0 gap-y-0.5 md:gap-y-0"
		>
			<DestinationRow
				v-for="(platform, index) in ctx.getSelectedGroup(group.selected)"
				:key="platform._id"
				:platform="platform"
				:index="index"
			/>
		</div>
	</div>
</template>
